/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_SignatureInputs */

const en_platform_signature = /** @type {(inputs: Platform_SignatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform Signature`)
};

const es_platform_signature = /** @type {(inputs: Platform_SignatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firma de la plataforma`)
};

const fr_platform_signature = /** @type {(inputs: Platform_SignatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signature de la plateforme`)
};

const de_platform_signature = /** @type {(inputs: Platform_SignatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plattform-Signatur`)
};

const ja_platform_signature = /** @type {(inputs: Platform_SignatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プラットフォームのシグネチャー`)
};

const zh_platform_signature = /** @type {(inputs: Platform_SignatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平台签名/标志`)
};

const ar_platform_signature = /** @type {(inputs: Platform_SignatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بصمة المنصة`)
};

const id_platform_signature = /** @type {(inputs: Platform_SignatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ciri Khas Platform`)
};

const it_platform_signature = /** @type {(inputs: Platform_SignatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firma della Piattaforma`)
};

const ru_platform_signature = /** @type {(inputs: Platform_SignatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платформенная подпись`)
};

const pt_platform_signature = /** @type {(inputs: Platform_SignatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assinatura da Plataforma`)
};

const ko_platform_signature = /** @type {(inputs: Platform_SignatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`플랫폼 시그니처`)
};

/**
* | output |
* | --- |
* | "Platform Signature" |
*
* @param {Platform_SignatureInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const platform_signature = /** @type {((inputs?: Platform_SignatureInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_SignatureInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_platform_signature(inputs)
	if (locale === "es") return es_platform_signature(inputs)
	if (locale === "fr") return fr_platform_signature(inputs)
	if (locale === "de") return de_platform_signature(inputs)
	if (locale === "ja") return ja_platform_signature(inputs)
	if (locale === "zh") return zh_platform_signature(inputs)
	if (locale === "ar") return ar_platform_signature(inputs)
	if (locale === "id") return id_platform_signature(inputs)
	if (locale === "it") return it_platform_signature(inputs)
	if (locale === "ru") return ru_platform_signature(inputs)
	if (locale === "pt") return pt_platform_signature(inputs)
	return ko_platform_signature(inputs)
});